import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontSizeInPx, FontWeight, LineHeightInPx, Spacing } from "@snapchat/snap-design-system";

export const formContainerStyle = css`
    width: 100%;
`;

export const LensCtaFormHeading = styled.h3`
    padding-bottom: ${Spacing.SM}px;

    font-size: 16px;
    font-weight: ${FontWeight.MEDIUM};
    line-height: 20px;
    color: ${Colors.Black.V200};
`;

export const LensCtaFormInfo = styled.p`
    padding-bottom: 19px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: ${LineHeightInPx.REGULAR}px;
    color: #16191c;
    letter-spacing: 0.2px;

    > span > .sds-base-button.ant-btn {
        font-size: ${FontSizeInPx.REGULAR}px;
    }
`;

export const LensCtaChild = styled.div`
    flex-grow: ${(props: { grow?: number }) => props.grow ?? 0};

    &:not(:last-child) {
        padding-right: 25px;
    }
`;
